import { IdNameList } from "../../../api/services/common/models";
import { CustomMenuValue } from "../../../components";
import { LabelValue } from "../../../helpers/types/common";

export const MdmAddActivityFormKeys = {
  activityName: "activityName",
  programFramework: "programFramework",
  projectFramework: "projectFramework",
  modality: "modality",
  units: "units",
} as const;

export interface MdmAddActivityFormTypeValues {
  activityName?: string;
  programFramework?: string[];
  modality?: string[];
  units?: string;
  projectFramework?: string[];
  searchType: string;
}

export interface MdmActivityTopicRowValue {
  id: string;
  topicName: string;
  deliverables: IdNameList[];
  activityStatus: string;
  participantStatus: string[];
  preference: IdNameList[];
  unit: string;
  measurement: string;
  localizedTopics: CustomMenuValue[];
  defaultValueExceptions: CustomMenuValue[];
  [key: string]: any;
}

export const MdmActivityTopicResultKey = {
  topicName: "topicName",
  deliverables: "deliverables",
  activityStatus: "activityStatus",
  participantStatus: "participantStatus",
  preference: "preference",
  unit: "unit",
  unitName: "unitName",
  measurement: "measurement",
  locale: "locale",
  exceptions: "exceptions",
} as const;

export const preferencesKey = {
  triggerBilling: "triggerBilling",
  countsTowardsLastContactDate: "countsTowardsLastContactDate",
  triggerTouchPointSurvey: "triggerTouchPointSurvey",
};

export interface UniqueTopicResultFiltersTypes {
  preferences: LabelValue[];
  activityStatus: LabelValue[];
  participantStatus: LabelValue[];
}
